(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection-list"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('.categories-slider').forEach(function (root) {
      const track = root.querySelector('.categories-slider__track');
      const prevBtn = root.querySelector('.categories-slider__controls button:first-child');
      const nextBtn = root.querySelector('.categories-slider__controls button:last-child');
      const progressFill = root.querySelector('.categories-slider__progress-fill');
      const tabs = root.querySelectorAll('.categories-slider__tab');
      const cards = root.querySelectorAll('.categories-slider__card');

      if (!track) return;

      function updateProgress() {
        const maxScroll = track.scrollWidth - track.clientWidth;
        if (maxScroll <= 0) {
          if (progressFill) progressFill.style.width = '100%';
          return;
        }
        const scrollPercentage = (track.scrollLeft / maxScroll) * 100;
        if (progressFill) progressFill.style.width = Math.max(20, scrollPercentage) + '%';
      }

      track.addEventListener('scroll', updateProgress);
      window.addEventListener('resize', updateProgress);
      updateProgress();

      if (prevBtn) {
        prevBtn.addEventListener('click', function () {
          track.scrollBy({ left: -300, behavior: 'smooth' });
        });
      }

      if (nextBtn) {
        nextBtn.addEventListener('click', function () {
          track.scrollBy({ left: 300, behavior: 'smooth' });
        });
      }

      tabs.forEach(function (tab) {
        tab.addEventListener('click', function () {
          const targetTab = tab.getAttribute('data-tab');
          tabs.forEach(function (t) { t.classList.remove('is-active'); });
          tab.classList.add('is-active');

          cards.forEach(function (card) {
            const cardTab = card.getAttribute('data-tab-group');
            card.style.display = (cardTab === targetTab) ? 'flex' : 'none';
          });

          track.scrollLeft = 0;
          updateProgress();
        });
      });
    });

    // --- Animación sutil de entrada (encabezado + tarjetas) ---
    const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (!prefersReducedMotion && 'IntersectionObserver' in window) {
      const revealTargets = document.querySelectorAll(
        '.categories-slider__reveal, .categories-slider__card'
      );

      const revealObserver = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry, index) {
          if (entry.isIntersecting) {
            // Pequeño escalonado entre tarjetas visibles a la vez
            const delay = entry.target.classList.contains('categories-slider__card') ? index * 40 : 0;
            setTimeout(function () {
              entry.target.classList.add('is-visible');
            }, delay);
            revealObserver.unobserve(entry.target);
          }
        });
      }, {
        threshold: 0.15,
        rootMargin: '0px 0px -30px 0px'
      });

      revealTargets.forEach(function (target) {
        revealObserver.observe(target);
      });
    } else {
      document.querySelectorAll('.categories-slider__reveal, .categories-slider__card').forEach(function (el) {
        el.classList.add('is-visible');
      });
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["editorial-story-slider"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    const components = document.querySelectorAll('[class*="edi-static-"]');

    const observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    }, {
      threshold: 0.1,
      rootMargin: '0px 0px -30px 0px'
    });

    components.forEach(function (component) {
      observer.observe(component);
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["explore-categories"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('.explore-categories').forEach(function (root) {
      const track = root.querySelector('.explore-categories__track');
      const prevBtn = root.querySelector('.explore-categories__controls button:first-child');
      const nextBtn = root.querySelector('.explore-categories__controls button:last-child');
      const progressFill = root.querySelector('.explore-categories__progress-fill');
      const tabs = root.querySelectorAll('.explore-categories__tab');
      const cards = root.querySelectorAll('.explore-categories__card');

      if (!track) return;

      function updateProgress() {
        const maxScroll = track.scrollWidth - track.clientWidth;
        if (maxScroll <= 0) {
          progressFill.style.width = '100%';
          return;
        }
        const scrollPercentage = (track.scrollLeft / maxScroll) * 100;
        progressFill.style.width = Math.max(20, scrollPercentage) + '%';
      }

      track.addEventListener('scroll', updateProgress);
      window.addEventListener('resize', updateProgress);
      updateProgress();

      if (prevBtn) {
        prevBtn.addEventListener('click', function () {
          track.scrollBy({ left: -300, behavior: 'smooth' });
        });
      }

      if (nextBtn) {
        nextBtn.addEventListener('click', function () {
          track.scrollBy({ left: 300, behavior: 'smooth' });
        });
      }

      tabs.forEach(function (tab) {
        tab.addEventListener('click', function () {
          const targetTab = tab.getAttribute('data-tab');

          tabs.forEach(function (t) { t.classList.remove('is-active'); });
          tab.classList.add('is-active');

          cards.forEach(function (card) {
            const cardTab = card.getAttribute('data-tab-group');
            card.style.display = (cardTab === targetTab || targetTab === 'all') ? 'flex' : 'none';
          });

          track.scrollLeft = 0;
          updateProgress();
        });
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
